import 'isomorphic-fetch';

import { getLoggingUri } from '../../utils/routeUtils';
import { extractTokens } from '../../utils/authUtils';

const logError = error => {
  const loggingUri = getLoggingUri();
  const { authToken, ...tokens } = extractTokens();

  return fetch(loggingUri, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify({ error: error.stack, data: tokens }),
  });
};

export default logError;
